import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

firebase.initializeApp({
  apiKey: 'AIzaSyCOCjcRGGearyImU9lVyaWyu7bZywSpODk',
  authDomain: 'urbansnap-7beb1.firebaseapp.com',
  databaseURL: 'https://urbansnap-7beb1.firebaseio.com',
  projectId: 'urbansnap-7beb1',
  storageBucket: 'urbansnap-7beb1.appspot.com',
  messagingSenderId: '622577280986',
  appId: '1:622577280986:web:748613973210c4be'
})
export const defaultStore = firebase.firestore()
export const defaultAuth = firebase.auth()
export const serverTime = firebase.firestore.FieldValue.serverTimestamp()
export const collectionType = firebase.firestore.CollectionReference
export const firebaseConnection = firebase
